import { Button, ButtonProps } from '@arco-design/web-react';
import { IconRefresh } from '@arco-design/web-react/icon';
import React from 'react';

export function ButtonRefresh(props: ButtonProps) {
  return (
    <Button icon={<IconRefresh />} {...props}>
      刷新
    </Button>
  );
}
